var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 32,
    viewBox: "0 0 102 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101 31C101 31 90.9841 25.375 87.25 25.375C83.5159 25.375 79.6397 28.1317 76 25.3796C72.3603 22.6275 71.6088 19.7395 68.5 21.625C65.3912 23.5105 62.4149 23.5105 61 21.625C59.5851 19.7395 60.9628 18.8125 56 18.8125C51.0372 18.8125 51.4785 13.5116 49.75 10.375C48.0215 7.23842 45.4738 3.97844 41 6.625C36.5262 9.27156 33.4787 7.52644 32.25 5.6875C31.0213 3.84856 29.9973 2.875 27.25 2.875C24.5027 2.875 24.528 4.75 22.25 4.75C19.972 4.75 19.2506 6.625 16 6.625C12.7494 6.625 10.9068 1.93986 8.5 1.93986C6.09315 1.93986 1 1 1 1V31H101Z",
    fill: "url(#paint0_linear_1295_995)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101 31C101 31 90.9841 25.375 87.25 25.375C83.5159 25.375 79.6397 28.1317 76 25.3796C72.3603 22.6275 71.6088 19.7395 68.5 21.625C65.3912 23.5105 62.4149 23.5105 61 21.625C59.5851 19.7395 60.9628 18.8125 56 18.8125C51.0372 18.8125 51.4785 13.5116 49.75 10.375C48.0215 7.23842 45.4738 3.97844 41 6.625C36.5262 9.27156 33.4787 7.52644 32.25 5.6875C31.0213 3.84856 29.9973 2.875 27.25 2.875C24.5027 2.875 24.528 4.75 22.25 4.75C19.972 4.75 19.2506 6.625 16 6.625C12.7494 6.625 10.9068 1.93986 8.5 1.93986C6.09315 1.93986 1 1 1 1",
    stroke: "#CD3D42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1295_995",
    x1: 100.787,
    y1: 1,
    x2: 100.787,
    y2: 30.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD3D42",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3D42",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP1);
export default __webpack_public_path__ + "static/media/P1.488dc3c0619ce57e8a74b8aad6daf507.svg";
export { ForwardRef as ReactComponent };